// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"0e3508f1","282":"741b85ec","320":"c1834fe0","472":"2a199c23"}[chunkId] + ".chunk.js";
};